import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useEffect, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, Col, Row, Button, CardFooter } from "reactstrap";
import ReactTableGeneric from "Components/ReactTableGeneric";
import DocModel from "Components/Modal/DocumentModel/index";
import { ReactComponent as Calendar } from "../../../../assets/utils/images/svgs/Calendar.svg";
import { ReactComponent as Delete } from "../../../../assets/utils/images/svgs/Delete.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/utils/images/svgs/Eye-icon.svg";
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from "moment";
import { ReactComponent as CrossIcon } from "../../../../assets/utils/images/svgs/Cross.svg";
import DatePicker, { registerLocale } from "react-datepicker";
import nl from "date-fns/locale/nl";
import TextLimit from "Api/TextLimit";
import TitleModal from "Components/Modal/InfoModal/TitleModal";
import "./bewaartermijn-popover.scss";
import { useDeleteDocument, useDocuments, useDownloadDocument, useUpdateReminderDate } from "Api/Vervanger/Document";
import axiosInstance from "Api";

registerLocale("nl", nl);

const Default = () => {
    const [openModel, setOpenModel] = useState(false);
    const [file, setFile] = useState("");
    const [formData, setFormData] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showConfirmUpdateModal, setShowConfirmUpdateModal] = useState(false);
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [deleteDocId, setDeleteDocId] = useState(null);

    const { data: downloadData, mutate } = useDownloadDocument();
    const { trigger: updateReminderDateTrigger } = useUpdateReminderDate();

    const {
        data: documentResponse,
        isLoading,
        mutate: refreshDocuments,
    } = useDocuments();

    const totalCount=documentResponse?.totalCount;

    const {
        data: deleteResponse,
    } = useDeleteDocument(deleteDocId);

    const data = documentResponse?.data || [];

    useEffect(() => {
        if (deleteResponse?.status) {
            refreshDocuments();
            setShowModal(false);
            setDeleteDocId(null);
        }
    }, [deleteResponse, refreshDocuments]);

    const saveFile = (file) => {
        setFile(file);
    }

    const toggleProfileCropPopup = val => {
        setOpenModel(val);
        if (val === false) {
            setFile("");
        }
    }

    const handleCroppedImage = (val) => {
        if (val !== '') {
        }
    }

    function isDateValid(dateStr) {
        return !isNaN(new Date(dateStr));
    }

    const checkDateFormat = (value) => {
        if (isDateValid(value)) {
            var year = value.slice(0, 4);
            if (year.includes("-")) {
                return value;
            }
            return moment(value).format("DD-MM-yyyy");
        }
        return value;
    }




    const confirmDelete = (id) => {
        setShowModal(true);
        setDeleteId(id);
    }

    const handleDeleteDocument = (id) => {
        setDeleteDocId(id);
    };

    const downloadFile = async (id) => {
        try {

            const response = await axiosInstance.get(`document/${id}`);

            if (response.data.file.download !== '') {
                const linkSource = response.data.file.download;
                const downloadLink = document.createElement("a");
                const fileName = "document." + response.data.file.extension;

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }
        } catch (error) {
            console.error(error);
        }
    };

    const messageSwitch = (type, addedDate, validUntil) => {
        switch (type) {
            case 'ID-kaart / Paspoort':
                return 'Dit document wordt 3 maanden na de datum ' + validUntil + ' automatisch verwijderd';
            case 'Salarisstrook t.b.v. inschaling':
                return 'Dit document wordt 3 maanden na datum ' + addedDate + ' automatisch verwijderd';
            case 'Inlichtingenstaat':
                return 'Dit document wordt 3 maanden na datum ' + addedDate + ' automatisch verwijderd';
            case 'Loonbelastingverklaring':
                return 'Dit document wordt 3 maanden na datum ' + addedDate + ' automatisch verwijderd';
            case 'Los document':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - PABO':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Onderwijsassistent':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Leraarondersteuner':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Klassenassistent':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Tweede graads lesbevoegdheid':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Logopedist':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Fysiotherapeut':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Orthopedagoog':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Psycholoog':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Psychologisch medewerker':
                return 'Dit document wordt niet automatisch verwijderd';
            case 'Diploma - Eerste graads lesbevoegdheid':
                return 'Dit document wordt niet automatisch verwijderd';
            default:
                return '--';
        }
    }

    const confirmUpdate = (id, date) => {
        if (date !== '') {
            setShowConfirmUpdateModal(true);
            let dataAppend = new FormData();
            dataAppend.append('doc_id', id);
            dataAppend.append('value', moment(date).format('YYYY-MM-DD'));
            setFormData(dataAppend);
        } else {
            setShowConfirmDeleteModal(true);
            let dataAppend = new FormData();
            dataAppend.append('doc_id', id);
            dataAppend.append('value', '');
            setFormData(dataAppend);
        }
    }

    const updateHerinneringDate = async () => {
        try {
            const response = await updateReminderDateTrigger({
                data: formData,
            });

            if (response.status) {
                refreshDocuments();
                setShowConfirmUpdateModal(false);
                setShowConfirmDeleteModal(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const columns = [
        {
            header: 'Document',
            accessorKey: 'vLabel',
        },
        {
            header: 'Geldig tot',
            accessorKey: 'verloopdatum',
            cell: value => (
                value.row.original.verloopdatum !== '' &&
                checkDateFormat(value.row.original.verloopdatum)
            )
        },
        {
            header: 'Toegevoegd',
            accessorKey: 'toegevoegd'
        },
        {
            header: 'Herinnering',
            accessorKey: 'herinneringdatum',
            cell: value => (
                value.row.original.herinneringdatum !== '' &&
                <div className="d-flex justify-content-between align-items-center">
                    <span>{checkDateFormat(value.row.original.herinneringdatum)}</span>
                    <span><CrossIcon color={'#FB2E5F'} fontSize={"28px"}
                        onClick={(date) => confirmUpdate(value.row.original.id, '')} /></span>
                </div>
            )
        },
        {
            header: '',
            accessorKey: 'id',
            cell: value => (
                <label>
                    <Calendar />
                    <DatePicker
                        locale="nl"
                        clearButtonTitle="Clear"
                        className="hide-datepicker"
                        onChange={(date) => confirmUpdate(value.row.original.id, date)}
                    />
                </label>
            )
        },
        {
            header: 'Bestuur',
            accessorKey: 'vCommunityName',
            cell: value => (
                window.innerWidth > 1250 ?
                    TextLimit.limitStringLargeScreen(value.row.original.vCommunityName)
                    : TextLimit.limitStringSmallScreen(value.row.original.vCommunityName)
            )
        },
        {
            header: 'Opmerking',
            accessorKey: 'omschrijving'
        },
        {
            header: 'Bewaarbeleid',
            accessorKey: 'vLabel',
            cell: value => (
                value.row.original.vLabel === 'VOG' ? (
                    <TitleModal
                        variant="bewaartermijn"
                        scopedBewaartermijnClass="vervanger-documenten-bewaartermijn"
                        title="Bewaartermijn van documenten"
                        data={
                            <>
                                <div className="bewaartermijn-popup__row">
                                    <span className="bewaartermijn-popup__label">VOG:</span>
                                    <span className="bewaartermijn-popup__value">3 maanden na verloopdatum van de VOG</span>
                                </div>
                                <div className="bewaartermijn-popup__row">
                                    <span className="bewaartermijn-popup__label">Overige documenten:</span>
                                    <span className="bewaartermijn-popup__value">3 maanden na datum toevoegen</span>
                                </div>
                            </>
                        }
                    />
                ) : (
                    <TitleModal
                        variant="bewaartermijn"
                        scopedBewaartermijnClass="vervanger-documenten-bewaartermijn"
                        title="Bewaartermijn van documenten"
                        data={messageSwitch(value.row.original.vLabel, value.row.original.toegevoegd, value.row.original.verloopdatum) || ''}
                    />
                )
            )
        },

        {
            header: '',
            accessorKey: 'vDocHref',
            cell: value => (<a href="javascript:void(0)" onClick={() => downloadFile(value.row.original.id)} className="anchor-action-link">
                <EyeIcon />
            </a>)
        },
        {
            header: '',
            accessorKey: 'id',
            cell: value => (
                <span onClick={() => confirmDelete(value.row.original.id)} style={{ cursor: 'pointer' }}><Delete /></span>
            )
        }

    ];

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="12" lg="12">
                            <Card className="main-card mb-3">
                                <CardBody className="p-3">
                                    <ReactTableGeneric
                                        data={data}
                                        columns={columns}
                                        tableClassName="mb-0 table table-borderless table-bordered table-sm table-hover documnent-table-style"
                                        filters={{ search: false, pagination: true, sorting: true }}
                                        count={totalCount}
                                    />
                                </CardBody>
                                <SweetAlert title="Wilt u het geselecteerde document verwijderen?" show={showModal}
                                    type="warning"
                                    onCancel={() => setShowModal(false)}
                                    onConfirm={() => handleDeleteDocument(deleteId)}
                                    cancelBtnText="Nee"
                                    confirmBtnText="Ja"
                                    showCancel={true}
                                />
                                <SweetAlert title="weet u zeker dat u de herinneringsdatum wilt bijwerken?" show={showConfirmUpdateModal}
                                    type="warning"
                                    onCancel={() => setShowConfirmUpdateModal(false)}
                                    onConfirm={() => updateHerinneringDate()}
                                    cancelBtnText="Nee"
                                    confirmBtnText="Ja"
                                    showCancel={true}
                                />
                                <SweetAlert title="Weet je zeker dat je dit wilt verwijderen?" show={showConfirmDeleteModal}
                                    type="warning"
                                    onCancel={() => setShowConfirmDeleteModal(false)}
                                    onConfirm={() => updateHerinneringDate()}
                                    cancelBtnText="Nee"
                                    confirmBtnText="Ja"
                                    showCancel={true}
                                />
                                <DocModel isOpen={openModel} togglePopup={toggleProfileCropPopup} croppedFile={handleCroppedImage} saveFile={saveFile} doc={file} updateData={refreshDocuments} classes="document-modal-style" />
                            </Card>
                        </Col>
                    </Row>
                </div>
            </TransitionOnLoad>
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="d-block d-flex chat-layout-footer__inner">
                    <div className="btn-align-right">
                        <Button className="custom-btn-width btn-color-style mb-2 me-2" size="sm" outline color="primary" onClick={toggleProfileCropPopup}>
                            Document toevoegen
                        </Button>
                        <a href="https://fd8.formdesk.com/cloosernl/vog" target="_blank" rel="noreferrer">
                            <Button className="custom-btn-width btn-color-style mb-2 me-2" size="sm" outline color="primary">
                                Aanvragen VOG
                            </Button>
                        </a>

                    </div>
                </CardFooter>
            </div>
        </Fragment>
    )
};

export default Default;